/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkDebtorCamtApplyDto } from '../models/work-debtor-camt-apply-dto';
import { WorkDebtorCamtApplyResultDto } from '../models/work-debtor-camt-apply-result-dto';
import { WorkDebtorCamtPaymentDto } from '../models/work-debtor-camt-payment-dto';
import { WorkUploadBankFileDto } from '../models/work-upload-bank-file-dto';

@Injectable({ providedIn: 'root' })
export class WorkDebtorsCamtImportV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `debtorsCamtImportV2ControllerPreview()` */
  static readonly DebtorsCamtImportV2ControllerPreviewPath = '/v2/debtors-camt-import/preview';

  /**
   * Required permissions: debtors:update, debtors:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `debtorsCamtImportV2ControllerPreview()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  debtorsCamtImportV2ControllerPreview$Response(
    params: {
      body: WorkUploadBankFileDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDebtorCamtPaymentDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDebtorsCamtImportV2Service.DebtorsCamtImportV2ControllerPreviewPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDebtorCamtPaymentDto>>;
      })
    );
  }

  /**
   * Required permissions: debtors:update, debtors:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `debtorsCamtImportV2ControllerPreview$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  debtorsCamtImportV2ControllerPreview(
    params: {
      body: WorkUploadBankFileDto
    },
    context?: HttpContext
  ): Observable<Array<WorkDebtorCamtPaymentDto>> {
    return this.debtorsCamtImportV2ControllerPreview$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDebtorCamtPaymentDto>>): Array<WorkDebtorCamtPaymentDto> => r.body)
    );
  }

  /** Path part for operation `debtorsCamtImportV2ControllerApply()` */
  static readonly DebtorsCamtImportV2ControllerApplyPath = '/v2/debtors-camt-import/apply';

  /**
   * Required permissions: debtors:update, debtors:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `debtorsCamtImportV2ControllerApply()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  debtorsCamtImportV2ControllerApply$Response(
    params: {
      body: WorkDebtorCamtApplyDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkDebtorCamtApplyResultDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDebtorsCamtImportV2Service.DebtorsCamtImportV2ControllerApplyPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkDebtorCamtApplyResultDto>;
      })
    );
  }

  /**
   * Required permissions: debtors:update, debtors:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `debtorsCamtImportV2ControllerApply$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  debtorsCamtImportV2ControllerApply(
    params: {
      body: WorkDebtorCamtApplyDto
    },
    context?: HttpContext
  ): Observable<WorkDebtorCamtApplyResultDto> {
    return this.debtorsCamtImportV2ControllerApply$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkDebtorCamtApplyResultDto>): WorkDebtorCamtApplyResultDto => r.body)
    );
  }

}
